import localConfig from '@/config';
import { QueryKeys } from '@/constants/queryKeys';
import { contentfulClient } from '@/utils';
import { useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { DiscoverPageSkeleton, DiscoverPageItem } from '../types';

type TransformedStructure = {
  mode: DiscoverPageItem[];
  synth: DiscoverPageItem[];
};

const fetchDiscoverPage = async () => {
  try {
    let content = [];

    if (localConfig.showContentLive) {
      content = (
        await contentfulClient.getEntries<DiscoverPageSkeleton>({
          content_type: 'discoverPage',
        })
      ).items;
    } else {
      content = (
        await axios.get<void, AxiosResponse<DiscoverPageSkeleton[]>>(`${localConfig.contentfulUrl}/discoverPage.json`)
      ).data;
    }

    const result: TransformedStructure = {
      mode: [],
      synth: [],
    };

    content.forEach((entry) => {
      const { type, items } = entry.fields;

      const resultSuggestions = (items || []).map((item) => ({
        ...item.fields,
        image: item.fields.image?.fields.file.url,
        icon: item.fields.icon?.fields.file.url,
      }));

      switch (type) {
        case 'Mode Terminal':
          result.mode = resultSuggestions;
          break;
        case 'Synth Terminal':
          result.synth = resultSuggestions;
          break;
      }
    });

    return result;
  } catch (e) {
    console.error(e);
    return;
  }
};

export const useDiscoverPage = (options = {}) => {
  return useQuery({
    queryKey: [QueryKeys.DISCOVER_PAGE],
    queryFn: fetchDiscoverPage,
    refetchOnWindowFocus: localConfig.showContentLive,
    ...options,
  });
};
